import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartCtx = createContext(null);

const STORAGE_KEY = "alimi_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) {}
  }, []);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((p) => p.product_id === product.id);
      if (existing) {
        return prev.map((p) =>
          p.product_id === product.id ? { ...p, quantity: p.quantity + qty } : p
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          image: product.images?.[0] || "",
          quantity: qty,
        },
      ];
    });
    toast.success("Aggiunto al carrello", { description: product.name });
    setOpen(true);
  };

  const updateQty = (product_id, qty) => {
    if (qty <= 0) return remove(product_id);
    setItems((prev) => prev.map((p) => (p.product_id === product_id ? { ...p, quantity: qty } : p)));
  };

  const remove = (product_id) => {
    setItems((prev) => prev.filter((p) => p.product_id !== product_id));
  };

  const clear = () => setItems([]);

  const total = items.reduce((sum, it) => sum + it.price * it.quantity, 0);
  const count = items.reduce((sum, it) => sum + it.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, updateQty, remove, clear, total, count, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartCtx);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
